import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fill-height ma-0 main-container"
}

import { computed, onBeforeMount, ref, onBeforeUnmount } from "vue";
import { preloadRequiredData } from "@/preload";
import { useStore } from "vuex";
import AppNavbar from "./components/Navigation/AppNavbar.vue";
import MobileAppbar from "./components/Navigation/MobileAppbar.vue";
import AppSnackbar from "./components/AppSnackbar.vue";
import MobileNav from "./components/Navigation/MobileNav.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const isOnline = ref(navigator.onLine)
const updateOnlineStatus = () => isOnline.value = navigator.onLine
const isLoggedIn = computed(() => store.getters["auth/isLoggedIn"]);

const changeVisibility = () => {
  if (document.visibilityState === "visible") {
    // The user has returned to your app
    preloadRequiredData()
  }
};

onBeforeMount(() => {
  preloadRequiredData();
  // document.addEventListener("visibilitychange", changeVisibility);
  window.addEventListener('online', updateOnlineStatus)
  window.addEventListener('offline', updateOnlineStatus)
});
onBeforeUnmount(() => {
  // document.removeEventListener("visibilitychange", changeVisibility);
  window.removeEventListener('online', updateOnlineStatus)
  window.removeEventListener('offline', updateOnlineStatus)
})


return (_ctx: any,_cache: any) => {
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    class: "main"
  }, {
    default: _withCtx(() => [
      (isLoggedIn.value)
        ? (_openBlock(), _createBlock(AppNavbar, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(AppSnackbar),
      (isLoggedIn.value)
        ? (_openBlock(), _createBlock(_component_v_app_bar, {
            key: 1,
            app: "",
            flat: "",
            class: "d-fixed d-sm-none appbar",
            height: "50"
          }, {
            default: _withCtx(() => [
              _createVNode(MobileAppbar)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, { class: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, { name: "show" }, {
                default: _withCtx(() => [
                  Component
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        Component
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: 0 }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (isLoggedIn.value)
        ? (_openBlock(), _createBlock(MobileNav, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})